export var html   = 'http://www.w3.org/1999/xhtml';
export var mathml = 'http://www.w3.org/1998/Math/MathML';
export var svg    = 'http://www.w3.org/2000/svg';
export var xlink  = 'http://www.w3.org/1999/xlink';
export var xml    = 'http://www.w3.org/XML/1998/namespace';
export var xmlns  = 'http://www.w3.org/2000/xmlns';

export default { html: html, mathml: mathml, svg: svg, xlink: xlink, xml: xml, xmlns: xmlns };

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/config/namespaces.js.map
